import { css } from 'aphrodite/no-important';
import React, { FC, useCallback, useContext, useEffect, useState } from 'react';
import { Event } from 'stream-chat';
import { ChatContext } from 'stream-chat-react';
import { VendorUserPresence } from '../VendorUserPresence/VendorUserPresence';
import { style } from './style';

export interface ChannelHeaderProps {
  name: string | undefined;
  email: string | undefined;
  channelImage: string | undefined;
  attendeeId: string | undefined;
  onUserPresenceChange: () => Promise<number>;
}
export const ChannelHeader: FC<ChannelHeaderProps> = (props) => {
  const { name = 'Vendor Channel', email, channelImage, onUserPresenceChange, attendeeId } = props;
  const styles = style();
  const { client } = useContext(ChatContext);
  const [vendorUserPresence, setVendorUserPresence] = useState(false);

  const handleUserPresenceChanged = useCallback(
    async (event: Event) => {
      const { user } = event;

      if (event.type === 'user.watching.start') {
        // when a vendor user started to watch, we know at least one is online
        user?.id !== attendeeId && setVendorUserPresence(true);
      } else if (event.type === 'user.watching.stop' || event.type === 'user.presence.changed') {
        if (user?.id !== attendeeId) {
          const count = await onUserPresenceChange();
          setVendorUserPresence(count > 0);
        }
      }
    },
    [attendeeId, onUserPresenceChange]
  );

  useEffect(() => {
    if (!client) return;
    client.on('user.watching.stop', handleUserPresenceChanged);
    client.on('user.watching.start', handleUserPresenceChanged);
    client.on('user.presence.changed', handleUserPresenceChanged);

    return () => {
      client.off('user.presence.changed', handleUserPresenceChanged);
      client.off('user.watching.start', handleUserPresenceChanged);
      client.off('user.watching.stop', handleUserPresenceChanged);
    };
  }, [attendeeId, client, handleUserPresenceChanged]);

  // for setting user presence
  useEffect(() => {
    const getUserPresence = async () => {
      try {
        const count = await onUserPresenceChange();
        setVendorUserPresence(count > 0);
      } catch (err) {
        console.error(`Error trying setup user presence in Chat: ${err}`);
      }
    };
    getUserPresence();
  }, [client, onUserPresenceChange]);
  return (
    <div className={css(styles.channelHeaderContainer)}>
      <div className={css(styles.channelHeaderHeading)}>
        <VendorUserPresence vendorName={name} vendorImage={channelImage} isOnline={vendorUserPresence} />
        <div className={css(styles.channelHeaderText)}>
          <p className={css(styles.channelHeaderName)}>{name}</p>
          {email && <p className={css(styles.channelHeaderSubtitle)}>{email}</p>}
        </div>
      </div>
    </div>
  );
};
